import './index.css';
import { MouseEventHandler } from 'react';
import constants from '../../constants';
interface Props {
  onPressExit?: MouseEventHandler;
}
const ExitButtonWrapper = ({ onPressExit }: Props) => {
  return (
    <div className="exitBtnWrapper">
      <button className="exitBtn" onClick={onPressExit}>
        <img className="exit_button" src={constants.Images.exit} />
      </button>
    </div>
  );
};
export default ExitButtonWrapper;
